import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthLayoutComponent } from './auth-layout.component';
import { AuthLayoutRoutingModule } from './auth-layout.routing';

@NgModule({
    imports: [
        CommonModule,
        AuthLayoutRoutingModule,
    ],
    declarations: [AuthLayoutComponent],
    exports: [],
})
export class AuthLayoutModule
{
}
